import { createContext, useContext, useEffect, useState } from "react";
import { http, expireAuth } from "@/lib/api";
import { toast } from "sonner";
import { translateError } from "@/i18n/errors";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const expired = () => { setUser(null); toast.info(translateError("Token expired")); };
    const check = () => {
      const token = localStorage.getItem("ptg_token");
      if (!token) { setUser(null); setReady(true); return; }
      http.get("/auth/me").then((r) => { if (localStorage.getItem("ptg_token") === token) setUser(r.data); }).catch(() => {}).finally(() => setReady(true));
    };
    window.addEventListener("ptg-auth-expired", expired);
    window.addEventListener("focus", check);
    check();
    return () => { window.removeEventListener("ptg-auth-expired", expired); window.removeEventListener("focus", check); };
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("ptg_token");
    if (!user || !token) return undefined;
    try {
      const payload = JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
      const timer = setTimeout(() => expireAuth(token), Math.max(0, payload.exp * 1000 - Date.now()));
      return () => clearTimeout(timer);
    } catch { expireAuth(token); return undefined; }
  }, [user]);

  const authenticate = async (mode, payload) => {
    const { data } = await http.post(`/auth/${mode}`, payload);
    localStorage.setItem("ptg_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const refreshUser = async () => {
    const { data } = await http.get("/auth/me");
    setUser(data);
    return data;
  };
  const logout = () => { localStorage.removeItem("ptg_token"); setUser(null); };

  return <AuthCtx.Provider value={{ user, ready, authenticate, refreshUser, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
